let proxy = ''

if (window.location.hostname === 'localhost') {
  proxy = 'http://localhost'
} else {
  proxy = window.location.origin
}

export default proxy
